import debounce from 'lodash/debounce'

export function getUniqueListBy<T>(arr: T[], key: string) {
  return [...new Map(arr.map(item => [item[key], item])).values()]
}

export function Debounce(delay: number) {
  return (target: any, prop: string) => {
    return {
      configurable: true,
      enumerable: false,
      value: debounce(target[prop], delay),
    }
  }
}

export function TimeOutPromise(func: () => void, delay: number = 300) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(func())
    }, delay)
  })
}
